import { Link } from 'react-router-dom';

export function Navbar(): JSX.Element {
  return (
    <div className="w-full bg-surface-0 border-b border-border-gray py-4 px-6">
      <div className="max-w-screen-xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <img
            src="/bc_logo.svg"
            alt="BeautifulCode"
            className="h-8 flex-shrink-0"
          />
        </div>
        <Link
          to="/login"
          className="px-4 py-2 text-sm font-medium text-white bg-[#CE3F4F] rounded-md hover:bg-[#b83a48] transition-colors"
        >
          Sign In
        </Link>
      </div>
    </div>
  );
}
